<script setup lang="ts">
import brandIcon from "../assets/icon128.png";
</script>

<template>
  <span class="brand-lockup">
    <img :src="brandIcon" width="34" height="34" alt="" />
    <span>
      <strong>图萃</strong>
      <small>1688 素材整理</small>
    </span>
  </span>
</template>
